<template>
  <van-dialog 
    class="pay-dialog"
    v-model="show" 
    :show-confirm-button="false"
  > 
    <div class="content">
      <template v-if="step == 0">
        <h3 class="title">线路开通通知</h3>
        <p class="intro">声明： <span class="em">各线路的搜索技术和内容均一致</span>，免费线路为官方自有线路，在自有能力范围以内尽可能提供给大家免费服务。付费线路是来自赞助商的线路，非强制要求付费，一切付费收入，均用来支付给相应赞助商的服务器、带宽及维护成本，会尽量保障稳定可用，但如遇到特殊情况或不可抗力，仅能做到最高99%的全年可用率，同时，本站特别声明并未从其中获取利益，请知晓！专线客服QQ：3553126275（<span class="em">仅负责专线稳定性反馈处理，不负责内容搜索相关服务</span>）！</p>
        <div class="package-wrap">
          <div 
            v-for="item in packages" 
            :key="item.pid" class="package-item" 
            :class="{'active': pid == item.pid }"
            @click="choosePackage(item.pid)"
          >
            <p class="name">{{item.name}}</p>
            <p class="price">￥{{item.price}}/季度</p>
            <p class="tip">{{item.intro}}</p>
          </div>
        </div>

        <div class="pay-wrap" v-if="!isWeixin">
          <p class="label">支付方式：</p>
          <div class="paytype-wrap">
            <div class="paytype" :class="{'active': paytype == 'alipay'}" @click="choosePaytype('alipay')">
              <van-icon class="alipay" name="alipay" /> 支付宝
            </div>
            <div v-if="!isMobile" class="paytype" :class="{'active': paytype == 'wxpay'}" @click="choosePaytype('wxpay')">
              <van-icon class="wxpay" name="wechat" /> 微信支付
            </div>
          </div>
          <div class="button-wrap">
            <van-button type="primary" @click="createOrder">提交订单</van-button>
          </div>
        </div>
      </template>
      
      <template v-if="step == 1">
        <h3 class="title">扫码支付</h3>
        <div class="qrcode-wrap">
          <template v-if="!this.isMobile && !this.isWeixin">
            <img :src="qrcode" @error="qrcodeError = true" class="qrcode" alt="支付二维码加载失败">
            <p class="tip" v-if="paytype == 'alipay' && !qrcodeExpired && !qrcodeError"><van-icon name="alipay" class="alipay" />请用支付宝扫码支付</p>
            <p class="tip" v-if="paytype == 'wxpay' && !qrcodeExpired && !qrcodeError"><van-icon name="wechat" class="wxpay" />请用微信扫码扫码支付</p>
          </template>
          <template v-if="this.isMobile || this.isWeixin">
            <img src="https://res.oodcd.cn/zhi/pay_confirm.png" class="confirm" alt="支付扫码">
          </template>
    
          <p class="tip danger" v-if="qrcodeExpired" @click="retry">订单已超时，点击重新创建订单 <van-icon name="replay" /></p>
        </div>

         <div class="button-wrap">
          <van-button @click="retry">重新选择套餐</van-button>
          <van-button type="primary" @click="confirmOrder">我已支付</van-button>
        </div>
      </template>

      <template v-if="step == 2">
        <h3>充值成功</h3>
        <div class="success-wrap">
          <van-icon name="success" class="success" />
          <p class="tip">当前的线路为 <span class="em">{{WAYS[userinfo.vipgrade]}}</span></p>
        </div>
         <div class="button-wrap">
          <van-button type="primary" @click="hidePayDialog">确定</van-button>
        </div>
      </template>
     </div>
    <van-icon class="close" name="cross" @click="hidePayDialog" />
  </van-dialog>
</template>

<script>
import { isWeixin, isMobile } from '@/utils/navigator'
import { getPayPackages, queryOrder, createOrder } from '@/api/pay'

export default {
  data () {
    return {
      step: 0,
      pid: '',
      show: true,
      isWeixin: false,
      isMobile: false,
      packages: [],
      paytype: 'alipay',
      qrcodeError: false,
      qrcodeExpired: false,
      qrcodeTimer: null,
      order_id: "",
      payurl: "",
      qrcode: "",
    }
  },
  async created () {
    this.isWeixin = isWeixin()
    this.isMobile = isMobile()
    const packages = await getPayPackages()
    this.packages = packages
    this.pid = this.packages[0].pid
  },
  destroyed () {
    this.qrcodeTimer && clearInterval(this.qrcodeTimer)
  },
  methods: {
    choosePackage (pid) {
      this.pid = pid
    },
    choosePaytype (paytype) {
      this.paytype = paytype
    },
    async createOrder () {
      this.$toast.loading('正在调起支付窗口')

      let paytype = this.paytype
      if (!this.isMobile && this.paytype == 'wxpay') {
        paytype = 'native'
      }
      
      if (this.isMobile && this.isWeixin) {
        paytype = 'jsapi'
      }

      const res = await createOrder({
        pid: this.pid, 
        plt: this.isMobile ? 'mobile': 'pc', 
        openid: this.openid,
        client: this.client, 
        paytype: paytype,
      })

      if (res.code == 0) {
        this.step = 1
        const { order_id, payurl, qrcode, jsapi } = res.data
        this.order_id = order_id
        this.qrcode = qrcode
        this.payurl = payurl

        if (this.paytype == 'alipay' && !this.isWeixin && this.isMobile) {
          window.location.href = payurl
        } else if (this.isWeixin || paytype == 'jsapi') {
          return window.location.href = payurl
        }

        // 查询订单支付状态
        let queryTimes = 0
        this.qrcodeTimer = setInterval(async () => {
          const res = await queryOrder({ order_id: this.order_id })
          if (res.code == 0) {
            await this.paySuccess()
          } else {
            queryTimes++
            if (queryTimes > 40) {
              this.qrcodeExpired = true
              this.qrcodeTimer && clearInterval(this.qrcodeTimer)
            }
          }
        }, 1500)
      } else {
        this.$toast.fail('创建订单出错，请稍后重试')
      }
    },
    async confirmOrder () {
      const res = await queryOrder({ order_id: this.order_id })
      if (res.code == 0) {
        await this.paySuccess()
      } else if (res.code == 10302) {
        return this.$toast.fail('检测到尚未支付')
      } else if (res.code == 10304) {
        return this.$toast.fail('支付平台出错，请联系网站管理员')
      } else if (res.code == 10303) {
        return this.$toast.fail('订单已过期')
      } else {
        this.$toast.fail('出现错误，请稍后重试')
      }
    },
    retry () {
      this.step = 0
      this.order_id = ''
      this.qrcode = ''
      this.payurl = ''
      this.qrcodeExpired = false
      this.qrcodeTimer && clearInterval(this.qrcodeTimer)
    },
    async paySuccess () {
      this.step = 2
      await this.updateUserinfo()
      this.qrcodeTimer && clearInterval(this.qrcodeTimer)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_var.scss';

.pay-dialog {
  width: 600px;
  border-radius: 4px;
  top: 40%;
  h3 {
    font-size: 17px;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .intro {
    font-size: 12px;
    color: #666;
    text-align: justify;
    margin-bottom: 10px;
  }
  .content {
    padding: 0px 30px 20px;
  }
  .package-wrap {
    display: flex;
    justify-content: space-between;
    .package-item {
      width: 31%;
      padding: 20px 10px;
      border-radius: 4px;
      border: 2px solid #ddd;
      text-decoration: none;
      text-align: center;
      color: #666;
      font-size: 13px;
      transition: all ease 0.2s;
      &:hover, &.active {
        cursor: pointer;
        border-color: $theme-color;
        color: $theme-color;
      }
      .price {
        margin-top: 15px;
        font-size: 22px;
        font-weight: bold;
      }
      .tip {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px dashed #eee;
      }
    }
  }
  .label {
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .pay-wrap {
    margin-top: 15px;
    .paytype-wrap {
      display: flex;
    }
    .paytype {
      display: inline-block;
      font-size: 13px;
      padding: 8px 20px;
      border-radius: 2px;
      margin-right: 10px;
      border: 2px solid #ddd;
      display: flex;
      align-items: center;
      transition: all ease 0.2s;
      .alipay {
        color: #1296db;
      }
      .wxpay {
        color: #45bb35;
      }
      i {
        font-size: 16px;
        margin-right: 5px;
      }
      &:hover, &.active {
        cursor: pointer;
        border-color: $theme-color;
      }
    }
  }

  .tip-wrap {
    text-align: center;
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .qrcode-wrap {
    text-align: center;
    .confirm {
      width: 240px;
    }
    .qrcode {
      padding: 10px;
      border: 1px solid #eee;
      background-color: #f5f5f5;;
      border-radius: 4px;
    }
    .tip {
      margin-top: 5px;
      font-size: 13px;
      display: flex;
      align-items: center;
      color: #666;
      justify-content: center;
      i {
        font-size: 20px;
      }
      &.danger {
        cursor: pointer;
        &:hover {
          font-weight: bold;
        }
        i {
          font-size: 15px;
          margin-left: 4px;
        }
      }
    }
  }

  .success-wrap {
    text-align: center;
    i {
      font-size: 80px;
    }
    .tip {
      margin-top: 10px;
      font-size: 13px;
      .num {
        font-size: 20px;
        font-weight: bold;
      }
    }
  }
  .button-wrap {
    margin-top: 15px;
    display: flex;
    justify-content: center;
    .van-button {
      height: 40px;
      width: 44%;
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }

  .warn-tip {
    margin-top: 10px;
    padding: 5px;
    color: rgb(128, 82, 50);
    font-size: 12px;
    border-radius: 2px;
    background-color: #fffbe8;
    text-align: justify;
    border: 1px solid rgba(73, 33, 5, 0.2);
  }
}

.van-dialog {
  overflow: visible;
}

.close {
  position: absolute;
  height: 36px;
  width: 36px;
  bottom: -46px;
  left: 50%;
  margin-left: -18px;
  color: #fff;
  font-size: 24px;
  border-radius: 50%;
  line-height: 36px;
  text-align: center;
  background-color: rgba(#000, 0.7);
  &:hover {
    cursor: pointer;
    background-color: #000;
  }
}

@media (max-width: 700px) {
  .pay-dialog {
    width: 94%;
    top: 45%;
    .content {
      padding: 15px;
    }
    .package-wrap {
      flex-direction: column;
      .package-item {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 8px 10px;
        justify-content: space-between;
        margin-bottom: 10px;
        &:last-of-type {
          margin-bottom: 0px;
        }
        .pd {
          .num {
            font-weight: normal;
            font-size: 13px;
          }
        }
      }
    }
  }
} 
</style>